import { render, staticRenderFns } from "./ShowCustomer.vue?vue&type=template&id=c821d826&scoped=true"
import script from "./ShowCustomer.vue?vue&type=script&lang=js"
export * from "./ShowCustomer.vue?vue&type=script&lang=js"
import style0 from "./ShowCustomer.vue?vue&type=style&index=0&id=c821d826&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c821d826",
  null
  
)

export default component.exports